<div class="content">
  <div class="login">
    <div class="login-logo-odm">
      <img src="{{logoPath}}">
    </div>
    <form>
      <div class="login-content">
        <section class="result-content">
          <i class="fa {{activate_result_status}} {{result_result_icon}}" aria-hidden="true"></i>
          <h2>{{activate_result_type}}</h2>
          <h3>{{activate_result}}</h3>
          <button type="submit" pButton label="{{'Go back to login' | translate}}" class="login-btn" (click)="confirmAccount()"></button>
        </section>
      </div>
    </form>
  </div>
</div>
